import React from 'react';

import * as S from './styled';

type Mask = string[] | { (): void };
type Props = {
  type?: string;
  mask?: Mask;
  inputRef: React.RefObject<HTMLElement>;
};

const TextInput = ({
  mask,
  inputRef,
  ...rest
}: Props) => (mask ? (
  <S.Masked
    {...rest}
    ref={inputRef}
    mask={mask}
  />
) : (
  <S.Input
    ref={inputRef}
    {...rest}
  />
));

TextInput.defaultProps = {
  type: 'text',
  mask: null,
};

export default TextInput;
